import { dayjs } from '@/utils/dayjs'

export const getFormatedDate = (date: Date): string => {
    return dayjs(date).format('DD/MM/yyyy')
}
